import { useEffect } from 'react';
import Button from '@components/Button';
import Modal from '@components/Modal';
import Title from '@components/Title';
import type { SeatItem } from '@modules/header/ShareConfigModal/types';
import { SeatsOptions } from './SeatsOptions';
import { SeatsSelected } from './SeatsSelected';
import { $seatsSelected, $seatsSelectedApi } from './seatsStores';
import { useModifySeatSetting } from './seatsApis';

interface SeatsModalProps {
  initialData: SeatItem[];
  onRequsetClose: () => void;
}

export function SeatsModal({ initialData, onRequsetClose }: SeatsModalProps) {
  useEffect(() => {
    return () => {
      $seatsSelectedApi.clear();
    };
  }, []);
  const modify = useModifySeatSetting();

  const handleConfirm = async () => {
    const selected = $seatsSelected.getState();
    const added: SeatItem[] = [];
    const deleted: SeatItem[] = [];
    // 检测新增的元素
    selected.forEach((selItem) => {
      const isExisting = initialData.some(
        (origItem) =>
          origItem.id === selItem.id &&
          origItem.accessScope === selItem.accessScope
      );
      if (!isExisting) {
        added.push(selItem);
      }
    });

    // 检测删除的元素
    initialData.forEach((origItem) => {
      const isSelected = selected.some(
        (selItem) =>
          selItem.id === origItem.id &&
          selItem.accessScope === origItem.accessScope
      );
      if (!isSelected) {
        deleted.push(origItem);
      }
    });
    await modify.mutateAsync({
      addData: added.map((x) => ({
        relationId: x.relationId,
        accessScope: x.accessScope,
      })),
      removeData: deleted.map((x) => x.id),
    });
    onRequsetClose();
  };

  return (
    <Modal
      isOpen
      style={{ width: 970, height: 620 }}
      onRequestClose={onRequsetClose}
      header={
        <div className="flex">
          <Title>选择企业成员</Title>
          <div className="ml-20 self-end text-orange">
            注：企业成员可以选择自己数据权限范围内的成员，也可以选择企业全员查看
          </div>
        </div>
      }
      footer={
        <Button disabled={modify.isLoading} onClick={handleConfirm}>
          确认选择
        </Button>
      }
    >
      <div className="relative flex h-full p-10">
        <SeatsOptions />
        <SeatsSelected />
      </div>
    </Modal>
  );
}

export default SeatsModal;
